import Dropdown from 'classes/Dropdown';

let animation = 'fade-in-bottom-short 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both';

export default class MB_Filter_Dropdowns {

    constructor(filters){

        this.filters = filters;

        filters.container.querySelectorAll('.mb_filter_dropdown').forEach(container=>{
            this.dropdown_init(container);
        })
    }

    dropdown_init(container){

        let dropdown = container.querySelector('select');
        let key = container.dataset.filter_key;

        this.filters.register_field(container);

        dropdown.addEventListener('change',()=>{
            this.filters.set_value(key, dropdown.value);
            this.filters.apply();
        });

        new Dropdown(dropdown, {
            animation_open: animation,
        });
    }

}